import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import BrandSpinner from "../assets/lottie/brand-spinner.lottie";
import { colors, sizes } from "../assets/themes";
import Icon from "./icon";

const Spinner = ({ className, size, brand, color = colors.primary, children }) => (
  <div className={className}>
    {brand ? (
      <DotLottieReact autoplay loop src={BrandSpinner} style={{ width: size, height: size }} />
    ) : (
      <Icon.Medium color={color} name="spinner" size={size} spin />
    )}
    {children && <span className="mt-3 text-center text-muted">{children}</span>}
  </div>
);

const Large = ({ className, ...rest }) => <Spinner brand size={sizes.size48} {...rest} />;
const Medium = ({ className, ...rest }) => <Spinner brand size={sizes.size32} {...rest} />;
const Small = ({ className, ...rest }) => <Spinner size={sizes.size16} {...rest} />;
export default { Large, Small, Medium };
